import React, {useEffect, useState} from 'react';
import {getCookie, setCookie} from 'typescript-cookie';
import {useSelector} from 'react-redux';
import {RootState} from '../../store/rootReducer';
import {roleTypes} from '../../utils/types';
import SelectRoleDialog from '../../components/organisms/Forms/SelectRole/component';
import StatisticsPage from '../Statistics/page';

const Home = () => {
    const [showSelectRoleDialog, setShowSelectRoleDialog] = useState(false);
    const currentUser = useSelector((state: RootState) => state);
    const roles: roleTypes[] = (currentUser.auth.user?.roles || []) as roleTypes[];

    const cookieRole = getCookie('roleType');

    useEffect(() => {
        if (!roles?.length) return;

        const cookie = getCookie('roleType');
        const firstRole = roles[0].roleType;

        const cookieMissingOrInvalid = !cookie || cookie === 'null' || !roles.some(r => r.roleType === cookie);

        if (cookieMissingOrInvalid) setCookie('roleType', firstRole, {path: '/'});
    }, [roles]);

    return (
        <div style={{minHeight: '100vh', overflow: 'auto'}}>
            {showSelectRoleDialog && (
                <SelectRoleDialog visible onClose={() => setShowSelectRoleDialog(false)}/>
            )}
            <StatisticsPage key={cookieRole}/>
        </div>
    );
};

export default Home;